var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowExpanded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 6,
    viewBox: "0 0 4 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.29596 0C3.47675 0 3.65059 0.0631413 3.78966 0.18311C4.06084 0.429361 4.06084 0.833465 3.78966 1.07972L1.68275 2.99921L3.79661 4.91871C4.0678 5.16496 4.0678 5.56906 3.79661 5.81531C3.52542 6.06156 3.0804 6.06156 2.80921 5.81531L0.201651 3.44751C0.0695345 3.32755 0 3.16969 0 2.99921C0 2.82873 0.076488 2.67088 0.201651 2.55091L2.80226 0.18311C2.94133 0.0631413 3.12212 0 3.29596 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowExpanded);
export default __webpack_public_path__ + "static/media/ArrowExpanded.fdcff3ecb3100e544c07da68e1cdf354.svg";
export { ForwardRef as ReactComponent };